<template>
  <div>
    <div class="partner-info">
      <div class="ach-panel">
        <div class="ach-warp">
          <div class="personal-info">
            <van-image fit="cover" :src="mallInfo.avatar || avatar" :alt="mallInfo.nickname" class="avatar" />
            <div class="personal-right">
              <p class="personal-name">{{ !pageInit ? '请登录' : mallInfo.nickname || mallInfo.patient.name }}</p>
              <p class="personal-tel">{{ !pageInit ? '登录后查看更多' : mallInfo.phone }}</p>
              <!-- <p class="personal-tel">{{ !pageInit ? '登录后查看更多' : $getGender(mallInfo.patient.gender) }}</p> -->
            </div>
          </div>
          <div class="ach-content" @click="toPointsDetail">
            <div>
              <p class="ach-title">会员积分</p>
              <p class="ach-num">
                <countTo separator="" :startVal="pointsInfo.memberPoints" :endVal="pointsInfo.memberPoints" />
              </p>
            </div>
            <div>
              <p class="ach-title">消费积分</p>
              <p class="ach-num">
                <countTo separator="" :startVal="pointsInfo.consumptionPoints" :endVal="pointsInfo.consumptionPoints" />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="personal-func-list" v-if="funcList.length">
        <cell
          v-for="(item, index) in funcList.filter(i => !i.show || i.show())"
          :key="index"
          is-link
          @click="toLink(item.link)"
        >
          <template #title>
            <span :class="['iconfont', `${item.icon}`]"></span>
            <span class="custom-title">{{ item.label }}</span>
          </template>
          <template #right-icon>
            <div class="right">
              <icon name="arrow" />
            </div>
          </template>
        </cell>
      </div>
    </div>
    <div style="height: 200px" />

    <opinion v-show="opinionModel.show" :show.sync="opinionModel.show" :info="opinionModel.info" />
    <qrcode v-if="qrcodeModel.show" :show.sync="qrcodeModel.show" :info="qrcodeModel.info" />

    <tabbar :curIndex="3" />
  </div>
</template>

<script>
import countTo from 'vue-count-to';
import tabbar from '../components/tabbar';
import opinion from '@/components/opinion';
import qrcode from '@/components/qrcode';

import services from '@/service';

import { Cell, Icon, Image as VanImage } from 'vant';
import { mapGetters } from 'vuex';
import { signOut, inviteUrl } from '@/lib/utils';
import { routerPush, notRequest, checkLogin } from '@/lib/utils';
import { isDev } from '@/global';

// import { adminAuth } from '@/global';

export default {
  name: 'mallPersonal',
  components: { countTo, tabbar, opinion, qrcode, Cell, Icon, VanImage },
  data() {
    return {
      avatar: this.$getImg('avatar'),
      opinionModel: {
        show: false,
        info: {}
      },
      qrcodeModel: {
        show: false,
        info: {}
      },
      pullLoading: false,
      pointsInfo: {
        memberPoints: 0,
        consumptionPoints: 0
      },
      searchVal: ''
    };
  },
  mounted() {
    if (!this.pageInit) return;

    this.refresh();
  },
  computed: {
    ...mapGetters(['mallInfo', 'userInfo']),
    pageInit() {
      return !notRequest();
    },
    funcList() {
      return [
        {
          label: '我的订单',
          icon: 'icon-wddd',
          link: '/mall-my-order'
        },
        {
          label: '权益卡',
          icon: 'icon-kcgl',
          link: '/mall-equity-card'
        },
        {
          label: '积分明细',
          icon: 'icon-cw',
          link: '/mall-points-details'
        },
        {
          label: '收货人管理',
          icon: 'icon-sh',
          link: '/mall-my-address'
        },
        {
          label: '用药人管理',
          icon: 'icon-wdywy',
          link: '/mall/medicine'
        },
        // {
        //   label: '意见反馈',
        //   icon: 'icon-kf',
        //   link: 'opinion'
        // },
        {
          label: '退出登录',
          icon: 'icon-tc',
          link: 'exit'
        }
      ];
    }
  },
  methods: {
    toPointsDetail() {
      routerPush({
        name: 'mallPointsDetails'
      });
    },
    async refresh() {
      // await Promise.all([this.$store.dispatch('set_mallInfo'), this.getOverview()]);
      await Promise.all([this.$store.dispatch('set_mallInfo'), this.getsPoints()]);
    },
    async getsPoints() {
      this.pointsInfo = (await services.mall.userPoints()).data;
    },
    async getOverview() {
      const res = await services.partner.getOverview();
      this.scoreInfo = res.data;
    },
    async toLink(path) {
      if (!isDev && path === '/partner-contract-list') {
        return this.$toast('功能即将上线');
      }
      await checkLogin();

      if (path === 'opinion') {
        this.opinionModel.show = true;
      } else if (path === 'qrcode') {
        this.qrcodeModel.show = true;
        this.qrcodeModel.info = {
          code: inviteUrl('partnerInviteEdit', this.partnerId),
          text: `${process.env.VUE_APP_TITLE} - ${this.mallInfo.sales.name}`
        };
      } else if (path === 'exit') {
        signOut();
      } else {
        path && this.$router.push(path);
      }
    },
    dialPhoneNumber(phoneNumber) {
      window.location.href = 'tel:' + phoneNumber;
    }
  }
};
</script>

<style lang="scss" scoped>
.partner-info {
  .line-title {
    margin: $tb $lr 0px;
  }
  .ach-panel {
    .ach-warp {
      margin: $tb $lr;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      color: #fff;

      .personal-info {
        background: url('../../../assets/img/pointBg.png');
        background-size: cover;
        background-position: center;
        padding: 20px $lr;
        line-height: 1.5;
        display: flex;
        align-items: center;

        .avatar {
          border-radius: 50%;
          width: 76px;
          height: 76px !important;
          border: 3px solid rgba(255, 255, 255, 0.8);
          margin-right: 16px;
          overflow: hidden;
          transition: transform 0.3s ease;
        }

        .personal-right {
          .personal-name {
            font-size: 22px;
            font-weight: 600;
            margin-bottom: 8px;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          }
          .personal-tel {
            font-size: $size4;
            opacity: 0.9;
          }
        }
      }

      .ach-content {
        display: flex;
        justify-content: space-around;
        padding: 16px $lr;
        > div {
          flex: 1;
          text-align: center;
          position: relative;

          &:not(:last-child):after {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 70%;
            background: rgba(0, 0, 0, 0.08);
          }
        }

        .ach-title {
          color: $gray2;
          font-size: $size6;
          margin-bottom: 8px;
        }

        .ach-num {
          font-size: 18px;
          font-weight: 600;
          color: $black1;
          transition: all 0.3s ease;
        }
      }
    }
  }

  .personal-func-list {
    margin: 0 $lr;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    :deep(.van-cell) {
      padding: 14px 16px;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.02);
      }

      .iconfont {
        font-size: 20px;
        // margin-right: 4px;
        color: $btnbg;
        vertical-align: middle;
      }

      .custom-title {
        font-size: 15px;
        vertical-align: middle;
      }
    }
  }
}
</style>
